var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('cliente',{attrs:{"Controlador":_vm.Controlador}})],1),_c('v-spacer'),_c('v-col',{attrs:{"cols":"auto"}},[_c('ventas',{attrs:{"Controlador":_vm.Controlador}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }